import { AutoSaveSavedIcon } from "./auto-save-saved.icon";
import { AutoSaveSavingIcon } from "./auto-save-saving.icon";
import { TypographyComponent } from "../typography/typography.component";
import { t } from "i18next";
import styles from "./auto-save.styles.module.scss";
import classnames from "classnames";

export type AutoSaveProps = {
  isSaving?: boolean;
  includeLabel?: boolean;
};
export const AutoSaveComponent = ({
  isSaving = false,
  includeLabel = true
}: AutoSaveProps) => (
  <div className={classnames(styles.root, styles.container)}>
    {includeLabel && (
      <TypographyComponent
        rootClassName={styles.text}
        styling={"p-sm"}
        boldness={"medium"}
      >
        {(isSaving ? t("Saving") : t("Changes saved"))}
      </TypographyComponent>
    )}
    {isSaving
      ? <AutoSaveSavingIcon className={classnames(styles.icon, styles.spinner)} />
      : <AutoSaveSavedIcon className={styles.icon} />
    }
  </div>
);
